const PRIVACY = "https://hubsfoundation.org/hubs-privacy-policy";
const TERMS = "https://hubsfoundation.org/hubs-terms-of-use";

module.exports = {
  PRIVACY,
  TERMS
};
